export default __webpack_public_path__ + "static/media/event1.74ab3095.png";